import {
  ChannelTypeInternal,
  GateFeatureTypeInternal,
  GateKindInternal,
  GateModeInternal,
} from '../../../../../../data-access/gql-types/graphql';

export const gateHasVentilation = (gateKind: GateKindInternal) => {
  return [
    GateKindInternal.OnePieceDoor,
    GateKindInternal.Sectional,
    GateKindInternal.RollUp,
    GateKindInternal.Unknown,
  ].includes(gateKind);
};

export const getGateMode = (supported: GateFeatureTypeInternal[], gateMode?: GateModeInternal | null) => {
  if (supported.length) {
    if (supported.includes(GateFeatureTypeInternal.StepByStep) && supported.includes(GateFeatureTypeInternal.SetDir)) {
      return GateModeInternal.RollUp;
    }

    if (supported.includes(GateFeatureTypeInternal.StepByStep)) return GateModeInternal.StepByStep;
    if (supported.includes(GateFeatureTypeInternal.SetDir)) return GateModeInternal.RollUp;
  }

  return gateMode || GateModeInternal.Unknown;
};

export const checkIfMicroventilationVisible = (ventilationSupported: boolean, calibrationNeeded: boolean) => {
  if (ventilationSupported && calibrationNeeded) return false;
  return ventilationSupported;
};

export const getGateGroupType = (gateKind?: GateKindInternal | null) => {
  if ([GateKindInternal.Doors].includes(gateKind!)) return ChannelTypeInternal.Door;
  if (
    [
      GateKindInternal.Barrier,
      GateKindInternal.DoubleLeaf,
      GateKindInternal.MultiBox,
      GateKindInternal.Wicket,
      GateKindInternal.Sliding,
    ].includes(gateKind!)
  ) {
    return ChannelTypeInternal.Fence;
  }

  return ChannelTypeInternal.Gate;
};
